import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  getData,
  createEditJobCharge,
} from "../../../redux/slices/JobChargeSlice";
import PageWrapper from "../../../pagecomponents/Common/PageWrapper";
import ModalWrapper from "../../../pagecomponents/Common/ModalWrapper";
import JobTypeAddEditForm from "./AddEditForm";
import { ToastContainer } from "react-toastify";
import DataTable from "../../../pagecomponents/Common/DataTable";
import { toastMessage } from "../../../helpers/utility.js";
import Swal from "sweetalert2";
import { deleteMasterData } from "../../../redux/api-calls/deleteMasterData.js";
import { MASTER_DATA_TYPE } from "../utils/constnsts.js";

const INIT_FORM_DATA = {
  job_charge_master_Id: 0,
  charge_Name: "",
  charge_Type: "",
  type: "create",
};

const JobCharges = () => {
  const dispatch = useDispatch();
  const pageName = "Job Charge";
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPage, setTotalPage] = useState(0);

  const PARAMS = {
    skip: 0,
    take: rowsPerPage,
    type: "job_charge",
    sorting: "asc",
    sorting_key: "created_at",
    filter: {},
  };

  const [data, setData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  // const [deleteAlertVisible, setDeleteAlertVisible] = useState(false);
  const [params, setParams] = useState(PARAMS);
  const [formData, setFormData] = useState(INIT_FORM_DATA);
  const [isEdit, setIsEdit] = useState(false);
  // const [isDelete, setIsDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSaveDisabled, setIsSaveDisabled] = useState(false);

  const openAddModal = () => {
    setIsEdit(false);
    setFormData(INIT_FORM_DATA);
    setModalVisible(true);
  };

  useEffect(() => {
    fetchMasterData();
  }, [params]);

  const fetchMasterData = async () => {
    setIsLoading(true);

    try {
      const { payload } = await dispatch(getData({ inputData: params }));
      setData(payload.job_charge);
      setTotalPage(Math.ceil(payload.job_charge_count / rowsPerPage));
    } catch (err) {
      toastMessage("error", "Failed to fetch data");
    } finally {
      setIsLoading(false); // Stop loader
    }
  };

  const handleSave = async (formData) => {
    console.log(formData);
    setIsSaveDisabled(true);

    const { payload } = await dispatch(
      createEditJobCharge({ inputData: formData })
    );
    if (payload?.status === "error") {
      setIsSaveDisabled(false);
      toastMessage("error", payload.msg || "An error occurred while saving.");
    } else {
      if (formData.type === "delete") {
        setIsSaveDisabled(false);
        // setDeleteAlertVisible(false);
        Swal.fire("Deleted!", "Your file has been deleted.", "success");
      } else {
        setIsSaveDisabled(false);
        toastMessage(
          payload?.status || "success",
          payload?.msg || "Operation successful."
        );
        closeModal();
      }

      // toastMessage(payload?.status || "success", payload?.msg || "Operation successful.");

      fetchMasterData();
    }
  };

  // Event handlers

  const openEditModal = (item) => {
    setIsEdit(true);
    setFormData({
      ...item,
      job_type_Code: item.job_type_Code || "",
      type: item.type || "",
    });
    setModalVisible(true);
  };

  const handleDelete = async (item) => {
    const data = await deleteMasterData({
      type: MASTER_DATA_TYPE.JOB_TYPE,
      id: item.job_charge_master_Id,
    });
    if (data.error || data.status === "error") {
      toastMessage(
        "error",
        data.msg ?? data.error ?? "An error occurred while saving."
      );
    }
    fetchMasterData();
  };

  const closeModal = () => {
    setModalVisible(false);
    setFormData(INIT_FORM_DATA);
  };

  const handleSort = (key) => {
    setCurrentPage(1);

    setParams((prev) => ({
      ...prev,
      skip: 0,
      sorting_key: key,
      sorting:
        prev.sorting_key === key && prev.sorting === "asc" ? "desc" : "asc",
    }));
  };

  const handleRowsPerPageChange = (rows) => {
    setRowsPerPage(rows);
    setCurrentPage(1);

    setParams((prev) => ({
      ...prev,
      take: rows,
      skip: 0,
    }));
  };

  const setPage = (pagenum) => {
    setCurrentPage(pagenum);
    setParams((prev) => ({
      ...prev,
      skip: (pagenum - 1) * prev.take,
    }));
  };

  const columns = [
    { label: "#", accessor: "index", sortable: false },
    { label: "Name", accessor: "charge_Name", sortable: true },
    { label: "Type", accessor: "charge_Type", sortable: true },
  ];

  return (
    <>
      <ToastContainer />
      <PageWrapper
        pageName={pageName}
        headerBtnTitle="+ Job Charge"
        onHeaderButtonClick={() => {
          openAddModal();
        }}
        showAddBtn={true}
      >
        <DataTable
          pageName={pageName}
          columns={columns}
          data={data}
          onEdit={openEditModal}
          onDelete={handleDelete}
          deleteEnabled
          onSorting={handleSort}
          sortingState={{ key: params.sorting_key, order: params.sorting }}
          currentPage={currentPage}
          totalPages={totalPage}
          rowsPerPage={rowsPerPage}
          updateRowsPerPage={handleRowsPerPageChange}
          onPageChange={setPage}
          loader={isLoading}
        />
      </PageWrapper>

      <ModalWrapper
        visible={modalVisible}
        onClose={closeModal}
        modalTitle={`${isEdit ? "Edit" : "Add"} ${pageName}`}
      >
        <JobTypeAddEditForm
          saveData={handleSave}
          closeModal={closeModal}
          formPayload={formData}
          isSaveDisabled={isSaveDisabled}
        />
      </ModalWrapper>
    </>
  );
};

export default JobCharges;
